import { keccak256, encodeAbiParameters, parseAbiParameters, type Hex } from 'viem';

const COMMITMENT_PARAMETERS = parseAbiParameters('bytes32, bytes32');

export function getSecureSeed(): number {
  try {
    if (typeof globalThis !== 'undefined' && globalThis.crypto?.getRandomValues) {
      const arr = new Uint32Array(1);
      globalThis.crypto.getRandomValues(arr);
      return arr[0] >>> 0;
    }
  } catch {
    // Fallback to Math.random if crypto is not available
  }
  return (Math.random() * 0xffffffff) >>> 0;
}

export function mix32(a: number, b: number): number {
  let x = (a ^ b) >>> 0;
  x = Math.imul(x ^ (x >>> 16), 0x45d9f3b) >>> 0;
  x = Math.imul(x ^ (x >>> 16), 0x45d9f3b) >>> 0;
  return (x ^ (x >>> 16)) >>> 0;
}

export function deriveSeed(sourceSeed: number, index: number, salt: number = 0): number {
  return ((sourceSeed ^ 0x9e3779b9) + index * 2654435761 + salt * 1103515245) >>> 0;
}

export function deriveSourceSeedFromCommitment(gameSeed: Hex, salt: Hex): number {
  const combinedSeed = keccak256(
    encodeAbiParameters(COMMITMENT_PARAMETERS, [gameSeed, salt])
  );
  const seedNumber = parseInt(combinedSeed.slice(2, 10), 16) % 1_000_000;
  return seedNumber;
}
